import React, { PureComponent, Fragment } from 'react';

import { injectIntl, InjectedIntl } from 'react-intl';

import Tooltip from '@atlaskit/tooltip';

import messages from './i18n';
import * as styles from './styled';

type BranchDivergenceProps = {
  intl: InjectedIntl;
  mainBranchName: string;
  commitsAhead?: number | null | undefined;
  commitsBehind?: number | null | undefined;
  isAvailable?: boolean;
};

// @ts-ignore TODO: fix noImplicitAny error here
export const calcWidth = (count: number) => {
  if (!count) {
    return 0;
  } else if (count === 1) {
    return (calcWidth(2) * 3) / 4;
  }
  return Math.min(Math.log(count) * 10, 100);
};

class BranchDivergence extends PureComponent<BranchDivergenceProps> {
  static defaultProps = {
    isAvailable: true,
  };

  renderAhead = () => {
    const { intl, commitsAhead, mainBranchName } = this.props;
    const message = intl.formatMessage(messages.commitsAheadMessage, {
      commitsAhead,
      mainBranchName,
    });
    return (
      <styles.DivergenceDisplay aria-label={message}>
        {commitsAhead !== null && (
          <styles.Graph type="ahead" width={calcWidth(commitsAhead || 0)} />
        )}
        <Tooltip content={message} position="bottom" delay={100}>
          <styles.Commits align="left">{commitsAhead}</styles.Commits>
        </Tooltip>
      </styles.DivergenceDisplay>
    );
  };

  renderBehind = () => {
    const { intl, commitsBehind, mainBranchName } = this.props;
    const message = intl.formatMessage(messages.commitsBehindMessage, {
      commitsBehind,
      mainBranchName,
    });
    return (
      <styles.DivergenceDisplay aria-label={message}>
        {commitsBehind !== null && (
          <styles.Graph type="behind" width={calcWidth(commitsBehind || 0)} />
        )}
        <Tooltip content={message} position="bottom" delay={100}>
          <styles.Commits align="right">{commitsBehind}</styles.Commits>
        </Tooltip>
      </styles.DivergenceDisplay>
    );
  };

  renderNotAvailable = () => {
    const { intl } = this.props;
    const message = intl.formatMessage(messages.notAvailableMessage);
    return (
      <styles.DivergenceDisplay aria-label={message}>
        <styles.Graph type="unavailable" />
        <Tooltip content={message} position="bottom" delay={100}>
          <styles.Hoverspace />
        </Tooltip>
      </styles.DivergenceDisplay>
    );
  };

  render() {
    const { commitsAhead, commitsBehind, isAvailable } = this.props;
    return (
      <styles.BranchDivergence>
        {isAvailable ? (
          <Fragment>
            {typeof commitsBehind === 'number' && this.renderBehind()}
            {typeof commitsAhead === 'number' && this.renderAhead()}
          </Fragment>
        ) : (
          this.renderNotAvailable()
        )}
      </styles.BranchDivergence>
    );
  }
}

export default injectIntl(BranchDivergence);
